export const FILTER_CONDITIONS = {
  GREATER_THAN: 'gt',
  GREATER_THAN_OR_EQUAL_TO: 'gte',
  LESSER_THAN: 'lt',
  LESSER_THAN_OR_EQUAL_TO: 'lte',
  NOT_EQUAL: 'neq',
};

export const buildFilter = (campo, valor, condicao) => {
  const filter = {
    campo,
    valor,
  };

  if (condicao) filter.condicao = condicao;

  return filter;
};
